
import React, { useEffect, useState } from "react";
import SliderLayout from "../components/SliderLayout";
import SliderOrig from "react-slick";

const Slider = SliderOrig as unknown as React.ComponentType<any>;

interface TabMainProp {
	listData: any
	getData: (date: string) => void
}

const TabMain = (props: TabMainProp) => {

	const { listData, getData } = props
	const [nav, setnav] = useState<any>([])
	const [listTitle, setListTitle] = useState<any>()
	const [currentDay, setCurrentDay] = useState<string>('')
	const [preDay, setPreDay] = useState<string>('')
	const [dayPre, setDayPre] = useState<string>('')
	const [nextDay, setNextDay] = useState<string>('')
	const [daynext, setDayNext] = useState<string>('')

	// utils/formatAndShiftDate.ts

	function formatToLongDate(dateStr: string): string {
		const date = new Date(dateStr);

		const day = date.getDate();
		const month = date.toLocaleString("en-US", { month: "long" });

		const getDaySuffix = (day: number): string => {
			if (day >= 11 && day <= 13) return "th";
			switch (day % 10) {
				case 1: return "st";
				case 2: return "nd";
				case 3: return "rd";
				default: return "th";
			}
		};

		return `${month} ${day}${getDaySuffix(day)}`;
	}

	function getPreviousDate(dateStr: string): string {
		const date = new Date(dateStr);
		date.setDate(date.getDate() - 1);
		return formatToYMD(date);
	}

	function getNextDate(dateStr: string): string {
		const date = new Date(dateStr);
		date.setDate(date.getDate() + 1);
		return formatToYMD(date);
	}

	// Helper: format Date → yyyy-mm-dd
	function formatToYMD(date: Date): string {
		const yyyy = date.getFullYear();
		const mm = `${date.getMonth() + 1}`.padStart(2, "0");
		const dd = `${date.getDate()}`.padStart(2, "0");
		return `${yyyy}-${mm}-${dd}`;
	}


	useEffect(() => {
		let imgLink = `/images/numerlogist/dailynumberreading_${listData.calculated_number}.png`

		const dataBehavior = listData.daily_index.filter((item: any) => item.type === "behavior")
		const dataRisk = listData.daily_index.filter((item: any) => item.type === "risk")
		const dataEmotion = listData.daily_index.filter((item: any) => item.type === "emotion")
		const dataPattern = listData.daily_index.filter((item: any) => item.type === "pattern")
		const dataPractice = listData.daily_index.filter((item: any) => item.type === "practice")

		const data = [
			{ id: 1, img: "/images/numerlogist/diamond.png", title: `${dataBehavior[0].type ? dataBehavior[0].type : '' } Insight`, mainTitle: dataBehavior[0].title ? dataBehavior[0].title : '', content: dataBehavior[0].description ? dataBehavior[0].description : '' },
			{ id: 2, img: "/images/numerlogist/star.png", title: `${dataRisk[0].type ? dataRisk[0].type : '' } Insight`, mainTitle: dataRisk[0].title ? dataRisk[0].title : '', content: dataRisk[0].description ? dataRisk[0].description : '' },
			{ id: 3, img: imgLink, title: `${dataEmotion[0].type ? dataEmotion[0].type : '' } Insight`, mainTitle: dataEmotion[0].title ? dataEmotion[0].title : '', content: dataEmotion[0].description ? dataEmotion[0].description : '' },
			{ id: 4, img: "/images/numerlogist/crystalreading_6_icon.png", title: `${dataPattern[0].type ? dataPattern[0].type : '' } Insight`, mainTitle: dataPattern[0].title ? dataPattern[0].title : '', content: dataPattern[0].description ? dataPattern[0].description : '' },
			{ id: 5, img: "/images/numerlogist/planetreading_friday_icon.png", title: `${dataPractice[0].type ? dataPractice[0].type : '' } Insight`, mainTitle: dataPractice[0].title ? dataPractice[0].title : '', content: dataPractice[0].description ? dataPractice[0].description : '' },
		];

		setnav(data)

		// const title = listData.daily_index.map((item: any) => `YOUR DAILY ${item.type}`)

		const title = [
			`YOUR DAILY ${dataBehavior[0].type ? dataBehavior[0].type : ''}`,
			`YOUR DAILY ${dataRisk[0].type ? dataRisk[0].type : ''}`,
			`YOUR DAILY ${dataEmotion[0].type ? dataEmotion[0].type : ''}`,
			`YOUR DAILY ${dataPattern[0].type ? dataPattern[0].type : ''}`,
			`YOUR DAILY ${dataPractice[0].type ? dataPractice[0].type : ''}`,
		]
		
		setListTitle(title)

		const dayNow = formatToLongDate(listData.current_date ? listData.current_date : '2025-08-15')
		const previous = getPreviousDate(listData.current_date ? listData.current_date : '2025-08-15');
		setDayPre(previous)
  	const next = getNextDate(listData.current_date ? listData.current_date : '2025-08-15');
		setDayNext(next)

		setCurrentDay(dayNow)
		setPreDay(formatToLongDate(previous))
		setNextDay(formatToLongDate(next))
	}, [listData])

	return (
		<>
			{nav.length > 0 && <SliderLayout nav={nav} listTitle={listTitle}>
				{
					({ currentIndex, listTitle, sliderSingleRef, settingsSingle, nav }) => (
						<div className="numerlogy-tab">
							<div className="date-box">
								<div className="btn1 btn-prev" onClick={() => getData(dayPre)}>
									<div className="text-box">
										<p>PREVIOUS</p>
										<div className="date">{preDay}</div>
									</div>
								</div>
								<div className="date-content">
									<p className="date">{currentDay}</p>
									{listTitle?.map((item, index) => (
										<div key={index} className={`sub-title ${index === currentIndex ? 'active' : ''}`}>{item}</div>
									))

									}
									{/* <div className="sub-title">{listTitle?.[currentIndex]}</div> */}
								</div>
								<div className="btn1 btn-next" onClick={() => getData(daynext)}>
									<div className="text-box">
										<p>NEXT</p>
										<div className="date" style={{ whiteSpace: 'nowrap' }}>{nextDay}</div>
									</div>
								</div>
							</div>

							<div className="slider slider-single">
								<Slider ref={sliderSingleRef} {...settingsSingle}>
									{nav.map((item) => (
										<div key={item.id}>
											<div className="body-top">
												<h3 className="title">{item.mainTitle}</h3>
												<div className="desktop-only">
													{/* <div className="btn-green">
														UNLOCK THE <span>NEXT 30 DAYS</span>
													</div> */}
												</div>
											</div>
											<div className='body-content' dangerouslySetInnerHTML={{ __html: item.content }} />
										</div>
									))}
								</Slider>
							</div>
						</div>
					)
				}
			</SliderLayout>}
		</>
	);
};

export default TabMain;
